/**
 * @namespace Mixins
 * @exports Mixins/apiHealth
 * @description Admin-configured API Health warning, shared by the API Health list rows
 * and the sourcing "Retrieving Live Rates" details dialog. Expects a `provider` prop.
 * @date 2026/07/31
 * @license no license
 * @copywrite Answers In Retirement Limited
 */

export default {
	computed: {
		/**
		 * @name apiHealthActive
		 * @description Admin sets Good/Warning/Error (capitalised, hence the toLowerCase). Only Warning and
		 * Error count as active. Anything else (Good, or unset — e.g. the synthetic 'air' org, which has
		 * no organisation_provider row and so gets an apiHealth with no status) is not a warning.
		 */
		apiHealthActive() {
			return ['warning', 'error'].includes(this.provider?.apiHealth?.status?.toLowerCase());
		},

		/**
		 * @name apiHealthColor
		 * @description Doubles as the Vuetify `type` for v-alert and the `color` for the list row
		 */
		apiHealthColor() {
			return this.apiHealthActive ? this.provider.apiHealth.status.toLowerCase() : 'success';
		},

		/**
		 * @name apiHealthMessage
		 * @description Admin-configured message, or a generic fallback when the status is set but the message was left blank
		 */
		apiHealthMessage() {
			if (this.provider?.apiHealth?.message) return this.provider.apiHealth.message;
			return `This Provider is having issues with their API. Please speak to one of our support team for more details.`;
		}
	}
};
